import { defineStore } from 'pinia';

import { type Breadcrumb } from '../models';

export const useBreadcrumbStore = defineStore('breadcrumb', {
    state: () => ({
        breadcrumbs: [] as Breadcrumb[]
    }),
    actions: {
        setBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
            this.breadcrumbs = breadcrumbs;
        },
        clearBreadcrumbs(): void {
            this.breadcrumbs = [];
        }
    }
});